module.exports = __webpack_public_path__ + "img/feedback-logo-blue2.400861df.png";